module.exports = __webpack_public_path__ + "img/default.84482ab7.svg";